<template>
    <!--顶部切换开始-->
    <div class="content-top-box clearfix" style="overflow:hidden;" @contextmenu.stop.prevent="">
        <div class="arrow-box arrow-box-left fl" :style="{display:tabCalc>scrollWidth?'block':'none'}" @click="changeLeftFn" style="flex:1;">
            <img src="~@/assets/image/images/icons/icon_arrow_left.png" />
        </div>
        <div class="cut-normal fl" ref="scrollDom">
            <div class="right-top-tab cut-long120" :style="{width:`${tabCalc}px`,marginLeft:`${marginLeft}px`}">    
                <topMenu :item="n" :blockData="blockData" :newId="newIds" :basicTypes="basicType" v-for="(n,i) in tabNav"
                    :key="i" :newAppId="newAppIds" :index="i" :finalSequence="finalSequence"></topMenu>
            </div>
        </div>
        <div class="arrow-box arrow-box-right fl" :style="{display:tabCalc>scrollWidth?'block':'none'}" @click="changeRightFn">
            <img src="~@/assets/image/images/icons/icon_arrow_right.png" />
        </div>
    </div>
    <!--顶部切换结束-->
</template>

<script>
// import $ from 'jquery'
import Bus from '../../../bus.js';
import topMenu from './topMenu.vue';
export default {
    name:"topTab",
    components:{
      topMenu
    },
    props:{
        finalSequence:Array,
        tabActiveType:{
            default:'up',
            type:String
        },
        newAppId:String,
        blockData:{
            type:Object
        },
        nav:{
            default:() => ['个人','企业','商圈','社会'],
            type:Array
        },
        tempNav:{
            default:() => ['个人','企业','商圈','社会'],
            type:Array
        },
        refeshflag: {
            default:false,
            type:Boolean
        },
        title: {
            default:'',
            type:String
        },
        newId:String,
        basicTypes:Boolean
    },
    data(){
        return{
            tabNav:[],
            ids:[],
            speed:0,
            marginLeft:0,
            scrollWidth:0,
            //刚改的
            tabCalc:0
        }
    },
    mounted(){
        // this.tabNav = this.tempNav.filter((ite)=>ite.name);
        this.scrollWidth = this.$refs.scrollDom.clientWidth;
        this.initFloorDrag();
    },
    watch:{
        'nav':{
            handler(list){
            this.tabNav = [];
            var _this = this;
            this.$nextTick(()=>{
                // for (const t of list) {
                //     // 检查缓存中是否已经存在
                //     if (_this.tabNav.find(c => c.name === t.name && c.flowType === t.flowType && c.tabType === t.tabType)) {
                //     // 已经存在说明以前记录过，现在这个就是多余的，直接忽略
                //         continue;
                //     }
                //     // 不存在就说明以前没遇到过，把它记录下来
                //     _this.tabNav.push(t);
                // }
                list.forEach((elm) => {
                    if (elm.name) {
                        _this.tabNav.push(elm);
                    }
                })
            })
        },
        immediate: true
        },
        'refeshflag':function(){
            this.tabNav=this.tempNav.filter((ite)=>ite.name);
        },
        //刚改的
        'tabNav':function(val){
            if(val){
                var twid = 0;
                val.filter((ite) => ite.name).forEach(element => {
                if (element.name) {
                    twid += ((element.name.length * 16) + (element.acquiesceType ? 20 : 0) + 45)
                }
                });
                this.tabCalc = twid; 
            }
        },
        '$store.state.winWidth':function(val){
          this.scrollWidth = this.$refs.scrollDom.clientWidth;
        }
    },
    computed: {
        newAppIds(){
            return this.newAppId;
        },
        newIds(){
            return this.newId
        },
        basicType(){
            return this.basicTypes
        }
        
    },
    //跨级触发方法
    provide() {
        return {
        fatherMethod: this.tabSwitch,
        updateWidth: this.updateWidth,
        tabRight: this.tabRight
        }
    },
    methods:{
        tabRight(item,ev){
            //右键搜索功能所需参数
            window.$search = {item:item,area:'up',floor:this.blockData.id};
            window.$nodeId = '';
            window.$isBlock = this.blockData.flowEnName == 'meta-universe' ? 'yes' : '';
            window.$floorflowId = this.blockData;
            window.$changeFlowBlock = item.flowType;
            if (item.flowType == "flow") {
                window.$floorId = item.id;
            } else if (item.flowType == "block") {
                window.$blockId = item.id;
            }
            if (item.nodeId) {
                window.$nodeId = item.nodeId;
            }
            Bus.$emit('windowRight', ev, item ,this.blockData.flowEnName);
        },
        updateWidth(t){
            //接受下级新增宽度或减少宽度
            this.tabCalc += t;
        },
        changeLeftFn(){
            if(this.speed == 0){
                return false;
            }
            this.speed++;
            this.marginLeft = this.speed * 150;
        },
        changeRightFn(){
            if(this.tabCalc + this.marginLeft < this.scrollWidth){
                return false;
            }
            this.speed--;
            this.marginLeft = this.speed * 150;
        },
        tabSwitch(item,n){
            
            window.$changeFlowBlock = item.flowType;
            if (item.flowType == "flow") {
                window.$floorId = item.id;
            }else if(item.flowType == "block"){
                window.$blockId = item.id;
            }
            if (item.flowType == "standard"){
                return false;
            }
            if (item.nodeId) {
                window.$nodeId = item.nodeId;
            }
            if(this.IsMobile() && this.blockData.flowEnName == 'media-scene'){
                var pageAppId = item.pageUrl ? this.getQueryUrl(item.pageUrl,'appId') : '';
                // this.$router.push({ path: "deliverables", query: { appId: this.getQuery('appId'), blockId: item.id,floorflowId:this.blockData.id,pageAppId:pageAppId } });
                this.routerJump('push','deliverables',{ appId: this.getQuery('appId'), blockId: item.id,floorflowId:this.blockData.id,pageAppId:pageAppId },item.name);

                return;
            }
            //勾选的流程块不展示标签级

            this.$store.commit('setTopTabFlag',true);
            // this.$backArr.push(item);
            if(this.blockData.flowEnName == 'meta-universe'){
                this.$backArr.push({ 'item': item, 'obj': { refesh: true, activeTab: n, tabType: 'up' } });
            }
            this.$emit('changeTab',item,{refesh:true,activeTab:n,tabType:'up'});
            
        }
    }
}
</script>

<style lang="scss" scoped>
.arrow-box {
    width: 34px;height: 61px;text-align: center;line-height: 61px;cursor: pointer;margin: 0 20px;
    &:hover{background-color: #fafafa;}
    img{vertical-align: middle;}
}
.content-top-box {
    border-bottom: 1px solid #dddddd;
    height: 62px;
    width: 100%!important;
    min-height: 62px;
    .cut-normal {
    width: calc(100% - 148px);
    overflow: hidden;
    }
    .right-top-tab {
    overflow: hidden;
    height: 62px;
    margin-top: 1px;
    transition: .3s all;
    .right-tab {
        position: relative;
        cursor: pointer;
        display: inline-block;
        height: 60px;
        line-height: 61px;
        margin: 0 20px;
        font-size: 16px;
        &:hover {
            color: #0d78cf;
        }
        .first {
        position: absolute;
        right: -18px;
        top: 18px;
        background-color: #f30101;
        color: #ffffff;
        font-weight: bold;
        height: 12px;
        line-height: 12px;
        border-radius: 4px;
        padding: 1px 3px;
        font-size: 12px;
        }
    }
    .right-tab.curr {
        position: relative;
        border-bottom: 1px solid #0d78cf;
        color: #0d78cf;
    }
    .right-tab.color-blue {
        color: #0d78cf;
    }
    .right-tab.main {
        font-weight: bold;
        color: #0d78cf;
    }
    .right-tab.main.curr {
        font-weight: bold;
    }
    }
}

@media screen and (min-width:426px) and (max-width: 768px) { 
    .arrow-box{margin:0;}
    .content-top-box .cut-normal{widows:calc(100% - 68px);width:-webkit-calc(100% - 68px);}
    .content-top-box .right-top-tab .right-tab{font-size:14px;}
    .content-top-box .right-top-tab .right-tab,.arrow-box,
    .content-top-box .right-top-tab,.content-top-box,.content-top-box{
        height:40px;line-height:40px;min-height:40px;
    }
    .content-top-box .right-top-tab .right-tab .first{top:6px;}
    .content-top-box .right-top-tab .right-tab.curr{height:36px;line-height:36px;min-height:36px;}
}
</style>



// WEBPACK FOOTER //
// src/components/floorBlock/control/topTab.vue